import React from 'react'
import { Link } from 'react-router-dom';
import './Callaction.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "brochuer/Takshila-VLSI-Company-Brochure.pdf";
    window.open(pdfUrl);
};

const callaction = () => {
   
  return (
    <div class="call-action ws-section bg-2 pb-200 dark-bg">
        <div class="container text-center">
            <div class="row dark-bg">
                <div class="col-lg-12">
                    <h2 class="ws-section_heading pd-03">Explore Our VLSI Institute’s Advanced Curriculum</h2>
                </div>
            </div>
            
            <div class="row">
                <div class="p-2 col-lg-5 text-lg-end">
                    <a href="/product-category/vlsi-courses-for-freshers/">
                    <button class="btn-secondary btn-icon">Get Started <FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                    </a>
                </div>
                <div class="p-2 col text-lg-start">
                    <button class="btn-secondary btn-icon btn-outline-lt" onClick={onButtonpdf}>Download Takshila VLSI Brouchure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default callaction